module.exports = __webpack_public_path__ + "img/flag-en.d3ddd602.svg";